import { AppVersion } from '@ionic-native/app-version';

// Constants
import { APP_CONFIG } from '../constants/config.constant';

// Helpers
//AGUS REVISAR USOS DE ESTOS HELPERS
import { isNative, isAndroid, isIOS, loadVersion, saveVersion } from '../helpers';

export const AppValidator = {

    /**
     * Determina la información si el sistema está en estado de mantenimiento
     */
    AppIsMainteinment: () => {

        if( APP_CONFIG.MESSAGE?.ALERT?.mainteinment ) {

            const message = { ...APP_CONFIG.MESSAGE.ALERT.mainteinment };
            return message;
        }

        return { enabled: false };
    },

    /**
     * Indica si la versión actual está dentro del rango de la nueva versión
     * @param { String } currentVersion Versión que debería tener la aplicación, sacada de la configuración
     * @param { String } versionDevice Versión que tiene la app actualmente, sacada del dispositivo
     */
    AppHasRangeAccepted: ( currentVersion = '0.0.0', versionDevice = '0.0.0') => {

        const v1 = currentVersion.split('.');
        const v2 = versionDevice.split('.');

        // Mayor
        if ( Number(v2[0]) < Number(v1[0]) ) { return false; }
        // Minor
        if ( Number(v2[1]) < Number(v1[1]) ) { return false; }

        return true;
    }
};